import {store} from "../store/store";
import {getRequest} from "@/helpers/getRequest";
import {postRequest} from "@/helpers/postRequest";
import {validateToken} from "@/helpers/validateToken";
import {logout} from "@/features/auth";

const defaultValues = {method: "GET", body: {}, mustValidateToken: false, headers: {}};

export const API = async (endpoint = "", options = defaultValues) => {
  let {method = "GET", body = {}, mustValidateToken = false, headers = {}} = {...defaultValues, ...options};

  if (typeof mustValidateToken === undefined && endpoint.includes("secure")) {
    mustValidateToken = true;
  }

  if (typeof mustValidateToken === undefined && !endpoint.includes("secure")) {
    mustValidateToken = false;
  }

  const {dispatch, getState} = store;
  const online = getState().offline.online || navigator?.onLine;
  let fullUrl = "";

  if (typeof endpoint !== "string") {
    throw new Error("Specify a string endpoint URL.");
  }

  if (typeof method !== "string") {
    throw new Error("Specify a string method type.");
  }

  if (method !== "GET" && method !== "POST") {
    throw new Error("Specify a valid method type.");
  }

  if (!endpoint.includes("http")) {
    fullUrl = `${import.meta.env.VITE_API_ROOT}/${endpoint}`;
  } else {
    fullUrl = endpoint;
  }

  if (!online) {
    return Promise.reject(new Error("Method not allow if you are offline."));
  }

  if (mustValidateToken) {
    const isValidToken = await validateToken();

    if (!isValidToken) {
      dispatch(logout());
      return {error: true, message: "Token not valid"};
    }
  }

  if (method === "POST") {
    return postRequest(fullUrl, headers, body);
  } else {
    return getRequest(fullUrl, headers);
  }
};
